const Shape = {
    type: String,
    validator: (value) => {
        // The value must match one of these strings
        return [
            'rounded',
            'rounded-top',
            'rounded-end',
            'rounded-bottom',
            'rounded-start',
            'rounded-circle',
            'rounded-pill',
            'rounded-0',
            'rounded-1',
            'rounded-2',
            'rounded-3',
        ].includes(value);
    },
};
const Color = {
    type: String,
    validator: (value) => {
        // The value must match one of these strings
        return [
            'primary',
            'secondary',
            'success',
            'danger',
            'warning',
            'info',
            'dark',
            'light',
            'link',
            'transparent',
        ].includes(value);
    },
};
const TextColor = {
    type: String,
    validator: (value) => {
        return [
            'primary',
            'secondary',
            'success',
            'danger',
            'warning',
            'info',
            'dark',
            'light',
            'primary-emphasis',
            'secondary-emphasis',
            'success-emphasis',
            'danger-emphasis',
            'warning-emphasis',
            'info-emphasis',
            'light-emphasis',
            'body',
            'body-emphasis',
            'body-secondary',
            'body-tertiary',
            'black',
            'black-50',
            'white',
            'white-50',
        ].includes(value);
    },
};

export { Color, Shape, TextColor };
//# sourceMappingURL=props.js.map
